import {
  BESTSELLER_FILTER_TYPE_MAP
} from '../../../../constants/globalTypes'
import { LISTING_TYPE } from '../constants/listing'
import { TAB } from './SalesPerformance'
import { FIELD as TABLE_LINK_FIELD } from './RankingTable/RankingTable'

export const GA_CLICK_ACTION = {
  TAB: 'TAB',
  LISTING_OPTION: 'LISTING_OPTION',
  TABLE_SORT: 'TABLE_SORT',
  TABLE_LINK: 'TABLE_LINK',
  READ_MORE: 'READ_MORE'
}

export const GA_KEY = {
  TAB_PERF_CHART: 'TAB_PERF_CHART',
  TAB_RANKING_TABLE: 'TAB_RANKING_TABLE',
  LISTING_OPTION_ALL: 'LISTING_OPTION_ALL',
  LISTING_OPTION_ORDER: 'LISTING_OPTION_ORDER',
  TABLE_SORT_AMOUNT: 'TABLE_SORT_AMOUNT',
  TABLE_SORT_QUANTITY: 'TABLE_SORT_QUANTITY',
  TABLE_LINK_AVAILABLE_QUANTITY: 'TABLE_LINK_AVAILABLE_QUANTITY',
  READ_MORE: 'READ_MORE'
}

const GA_KEY_MAP = {
  [GA_KEY.LISTING_OPTION_ALL]: 'hour_allgd',
  [GA_KEY.LISTING_OPTION_ORDER]: 'hour_specgd',
  [GA_KEY.TAB_PERF_CHART]: 'hour_trendtab',
  [GA_KEY.TAB_RANKING_TABLE]: 'hour_ranktab',
  [GA_KEY.TABLE_SORT_AMOUNT]: 'hour_rank_orderamt',
  [GA_KEY.TABLE_SORT_QUANTITY]: 'hour_rank_ordercnt',
  [GA_KEY.TABLE_LINK_AVAILABLE_QUANTITY]: 'hour_rank_availcnt',
  [GA_KEY.READ_MORE]: 'hour_rank_moreitems'
}

export const getI13nModel = (action = {}, customizeI13nModel = {}) => {
  const { type, payload } = action
  let key
  switch (type) {
    case GA_CLICK_ACTION.TAB: {
      const map = {
        [TAB.PERF_CHART]: GA_KEY.TAB_PERF_CHART,
        [TAB.RANKING_TABLE]: GA_KEY.TAB_RANKING_TABLE
      }
      key = map[payload]
      break
    }
    case GA_CLICK_ACTION.LISTING_OPTION: {
      const map = {
        [LISTING_TYPE.ALL]: GA_KEY.LISTING_OPTION_ALL,
        [LISTING_TYPE.ORDER]: GA_KEY.LISTING_OPTION_ORDER
      }
      key = map[payload]
      break
    }
    case GA_CLICK_ACTION.TABLE_SORT: {
      const map = {
        [BESTSELLER_FILTER_TYPE_MAP.AMOUNT.key]: GA_KEY.TABLE_SORT_AMOUNT,
        [BESTSELLER_FILTER_TYPE_MAP.QUANTITY.key]: GA_KEY.TABLE_SORT_QUANTITY
      }
      key = map[payload]
      break
    }
    case GA_CLICK_ACTION.TABLE_LINK: {
      const map = {
        [TABLE_LINK_FIELD.AVAILABLE_QUANTITY]: GA_KEY.TABLE_LINK_AVAILABLE_QUANTITY
      }
      key = map[payload]
      break
    }
    case GA_CLICK_ACTION.READ_MORE:
      key = GA_KEY[type]
      break
    default:
      break
  }
  const i13nModel = {
    label: GA_KEY_MAP[key],
    ...customizeI13nModel
  }
  return i13nModel
}
